export class MessageJiGuangUserBody{
    message = '';
    jidUsername = '';
    name = '';
}
